import { render, staticRenderFns } from "./ProductImageEditor.vue?vue&type=template&id=61c0f5e6&scoped=true&"
import script from "./ProductImageEditor.vue?vue&type=script&lang=js&"
export * from "./ProductImageEditor.vue?vue&type=script&lang=js&"
import style0 from "./ProductImageEditor.vue?vue&type=style&index=0&id=61c0f5e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c0f5e6",
  null
  
)

/* custom blocks */
import block0 from "./ProductImageEditor.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VIcon,VImg,VList,VListItem,VListItemIcon,VListItemTitle,VMenu,VProgressCircular,VSnackbar})
